import configDefault from "./config-default";

const config = {
  ...configDefault,
  code: "lesbruyeres",
  companyName: "Centre sportif Les Bruyères",
  website: 'https://les-bruyeres.com/',
  notifyChannel: 'vel-lesbruyeres',
  htmlCustomCSS: "lesbruyeres.scss",
  onlyOneClub: true,
	header: {
    title: "Je m'abonne",
		logo: "/logo-les-bruyeres.svg"
	},
  payByCard: "PAYLINE",
  footer: {
    ...configDefault.footer,
    logo: "/logo-les-bruyeres-white.svg",
  },
  options: {
		title: "JE CHOISIS MES OPTIONS",
		message: "",
		nextLabel: "Suivant",
		useImg: false,
	},
  plans: {
    ...configDefault.plans,
    nofeesLabel: "Frais d'inscription à régler à l'accueil",
  }

};

export default config;
